export default {
  sm: `DATA CENTER GAK Sejong, Korea's largest hyperscale data center, leads the future data industry through cloud-based cutting-edge technology.`,
  md: `DATA CENTER GAK Sejong, Korea's largest hyperscale data center, leads the future data industry through cloud-based cutting-edge technology.`,
  lg: `DATA CENTER GAK Sejong, Korea's largest hyperscale data center, leads the 
  future data industry through cloud-based cutting-edge technology.`,
  xxl: `DATA CENTER GAK Sejong, Korea's largest hyperscale data center, leads the future data 
  industry through cloud-based cutting-edge technology.`,
};
